import { getDomainEnvironment } from '@/domains/core/platform/domains/getDomainEnvironment';

export const buildURL = (uuid: string) =>
  `https://cdn.${getDomainEnvironment()}manomano.com/media/ugc-customers-pictures/${uuid}?fit=inside&h=480&w=480`;
export const buildThumbnailURL = (uuid: string) =>
  `https://cdn.${getDomainEnvironment()}manomano.com/media/ugc-customers-pictures/${uuid}?fit=cover&h=132&w=132`;
